export default "/static/js/983a731f87e66ca025bbbca1ca7603ad.webp";